module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( first ) { 
__p+=' <h5>'+
((__t=( i18n.tc("LegacyUnitsLayout", "Select a device to start the migration process") ))==null?'':__t)+
'</h5> ';
 } else { 
__p+=' <h5>'+
((__t=( i18n.tc("LegacyUnitsLayout", "Select another device to continue the migration process") ))==null?'':__t)+
'</h5> ';
 } 
__p+=' <div data-region="units-container"></div><fieldset class="button-wrap"><button data-click="units-cancel">'+
((__t=( i18n.tc("LegacyUnitsLayout", "Cancel") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
